import React from 'react';
import {ReactComponent as LogoBig} from '../../../assets/images/side-bg/logoBig.svg';
import {ReactComponent as LogoShort} from '../../../assets/images/side-bg/logoSmall.svg';
import {Link} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';

const SideBgLogo = ({handleShortMenu, menuOpen}) => {
  return (
    <>
      <Link className='side-bg__logo' to={mainPath.home}>
        {!menuOpen ? <LogoShort /> : <LogoBig />}
      </Link>
      <div className='side-bg__back' onClick={handleShortMenu}>
        <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <rect x='0.5' y='0.5' width='35' height='35' rx='17.5' fill='#F5F2F6' />
          <rect x='0.5' y='0.5' width='35' height='35' rx='17.5' stroke='#CAC4D0' />
          <g clipPath='url(#clip0_631_26179)'>
            <path
              d='M30 18C30 20.3734 29.2962 22.6935 27.9776 24.6668C26.6591 26.6402 24.7849 28.1783 22.5922 29.0866C20.3995 29.9948 17.9867 30.2324 15.6589 29.7694C13.3311 29.3064 11.1929 28.1635 9.51472 26.4853C7.83649 24.8071 6.6936 22.6689 6.23058 20.3411C5.76755 18.0133 6.00519 15.6005 6.91344 13.4078C7.8217 11.2151 9.35976 9.34094 11.3332 8.02236C13.3065 6.70379 15.6266 6 18 6C21.1815 6.00344 24.2318 7.26883 26.4815 9.51852C28.7312 11.7682 29.9966 14.8185 30 18ZM14 18C13.9992 18.732 14.2668 19.4389 14.752 19.987C15.043 20.314 15.326 20.624 15.529 20.827L18.353 23.7C18.4434 23.7999 18.5531 23.8804 18.6754 23.9369C18.7978 23.9933 18.9302 24.0244 19.0649 24.0284C19.1996 24.0323 19.3336 24.0091 19.4591 23.9599C19.5845 23.9108 19.6987 23.8368 19.7949 23.7424C19.891 23.648 19.9671 23.5352 20.0185 23.4107C20.07 23.2862 20.0957 23.1525 20.0942 23.0178C20.0927 22.8831 20.0641 22.7501 20.0099 22.6267C19.9557 22.5034 19.8772 22.3922 19.779 22.3L16.95 19.42C16.763 19.232 16.509 18.952 16.25 18.661C16.0889 18.4783 15.9999 18.2431 15.9999 17.9995C15.9999 17.7559 16.0889 17.5207 16.25 17.338C16.508 17.048 16.762 16.768 16.943 16.586L19.779 13.7C19.8772 13.6078 19.9557 13.4966 20.0099 13.3733C20.0641 13.2499 20.0927 13.1169 20.0942 12.9822C20.0957 12.8475 20.07 12.7138 20.0185 12.5893C19.9671 12.4648 19.891 12.352 19.7949 12.2576C19.6987 12.1632 19.5845 12.0892 19.4591 12.0401C19.3336 11.9909 19.1996 11.9677 19.0649 11.9716C18.9302 11.9756 18.7978 12.0067 18.6754 12.0631C18.5531 12.1196 18.4434 12.2001 18.353 12.3L15.524 15.179C15.324 15.379 15.044 15.686 14.755 16.012C14.2682 16.5598 13.9995 17.2672 14 18Z'
              fill='#55217E'
            />
          </g>
          <defs>
            <clipPath id='clip0_631_26179'>
              <rect width='24' height='24' fill='white' transform='matrix(-1 0 0 1 30 6)' />
            </clipPath>
          </defs>
        </svg>
      </div>
    </>
  );
};

export default SideBgLogo;
